enum FileAccessLevelsEnum {
  Level1 = 'Level 1',
  Level2 = 'Level 2',
}

export default FileAccessLevelsEnum;
